import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/mercari-seller-protection';

export default function Example() {
  return (
    <>
      <Head>
        <title>Protect your Mercari Business - Mercari`s Seller Protection</title>
        <meta
          name='description'
          content='Mercari is a selling platform for almost everything under the sun. It is ideal for sellers who have a myriad of different items to offer and wish to house them on one platform or those looking for another outlet to sell items under categories not hosted by other online marketplaces like Poshmark.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/mercari-seller-protection' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/mercari-seller-protection' />
        <meta property='og:title' content='Protect your Mercari Business - Mercari`s Seller Protection' />
        <meta
          property='og:description'
          content='Mercari is a selling platform for almost everything under the sun. It is ideal for sellers who have a myriad of different items to offer and wish to house them on one platform or those looking for another outlet to sell items under categories not hosted by other online marketplaces like Poshmark.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
